export default __webpack_public_path__ + "img/animation.89b68bdc.svg";